import { useLocation } from "@reach/router"

export const useAnalytics = gameId => {
  // useEffect(() => {
  const dnow = Date.now()
  const location = useLocation()
  const params = new URLSearchParams(location.search)
  const param_boxname = "co-op-game"
  const param_pageid = params.get("game-id")
  const param_lang_orig = "nl-BE"
  const param_lang = param_lang_orig.substring(0, 2)
  const boxUrl = `/EDUbox/games/${param_boxname}/`
  const trackUrl = `${boxUrl}${param_pageid}/`
  const pageTitle = `EDUbox co-op game: ${param_pageid}`
  const baseUrl = `https://${location.hostname}`
  const pageUrl = `${baseUrl}/${trackUrl}`

  if (typeof digitalData !== "undefined") {
    digitalData.events.push({
      event: {
        schema: "iglu:be.vrt/page_impression/jsonschema/1-1-0",
        data: {
          timestamp: dnow,
        },
      },
      context: [
        {
          schema: "iglu:be.vrt/context_page/jsonschema/1-2-1",
          data: {
            pagename: trackUrl,
            touchpointbrand: "vrt",
            contentbrand: "edubox",
            pageurl: pageUrl,
            pagetitle: pageTitle,
            domain: "www.vrt.be",
            pagepath: trackUrl,
            pagelanguage: param_lang,
            sitesection1: "",
            sitesection2: "",
            sitesection3: pageTitle,
            sitesection4: "",
            pageid: `vrtedubox${trackUrl}`,
          },
        },
      ],
    })
  }
  // }, [])
}
